import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";

const RELATIONSHIP_OPTIONS = [
  "Client",
  "Employee",
  "Vendor / Partner",
  "Member of the Public",
  "Other",
];

const CATEGORY_OPTIONS = [
  "Service Quality",
  "Billing / Payment",
  "Staff Conduct",
  "Data Privacy",
  "Other",
];

const GrievanceForm = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [relationship, setRelationship] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setFullName("");
    setEmail("");
    setPhoneNumber("");
    setRelationship("");
    setCategory("");
    setDescription("");
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const flowUrl = process.env.REACT_APP_GRIEVANCE_FLOW_URL;
    if (!flowUrl) {
      swal({
        title: "Grievance submission isn't configured yet.",
        text: "Please contact us directly at info@outcess.com in the meantime.",
        icon: "error",
        button: "Close",
      });
      return;
    }

    setLoading(true);
    try {
      await axios.post(
        flowUrl,
        {
          fullName,
          email,
          phoneNumber,
          relationship,
          category,
          description,
          submittedAt: new Date().toISOString(),
        },
        { headers: { "Content-Type": "application/json" } }
      );

      swal({
        title: "Your grievance has been submitted successfully!",
        text: "Our team will review it and get back to you.",
        icon: "success",
        button: "Close",
      });
      resetForm();
    } catch (error) {
      swal({
        title: "We couldn't submit your grievance.",
        text: "Please try again or email us at info@outcess.com.",
        icon: "error",
        button: "Close",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section className="contact-info-area ">
        <div className="row">
          <div
            className="col-xl-12 col-lg-12 col-md-12 col-sm-12"
            style={{ paddingLeft: "0px", paddingRight: "0px" }}>
            <div className="contact-form">
              <div className="row">
                <div className="col-xl-12">
                  <div className="sec-title-style1 float-left">
                    <div className="title" data-aos="fade-left">
                      SUBMIT A GRIEVANCE
                    </div>
                    <div className="text">
                      <div className="decor-left">
                        <span></span>
                      </div>
                      <p>We take every concern seriously</p>
                    </div>
                  </div>
                  <div className="text-box float-right">
                    <h3>
                      Have a <span style={{ color: "#f04217" }}>concern </span>{" "}
                      or complaint?
                    </h3>
                  </div>
                </div>
              </div>
              <div className="inner-box">
                <form id="grievance-form" onSubmit={submitHandler}>
                  <div className="row">
                    <div className="col-xl-6 col-lg-12">
                      <div className="row">
                        <div className="col-xl-12">
                          <div className="input-box">
                            <input
                              className="input-box-textarea"
                              type="text"
                              placeholder="Full Name"
                              required
                              name="fullName"
                              id="fullName"
                              value={fullName}
                              onChange={(e) => setFullName(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="input-box">
                            <input
                              className="input-box-textarea"
                              type="email"
                              name="email"
                              id="email"
                              placeholder="Email Address"
                              required
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="input-box">
                            <input
                              className="input-box-textarea"
                              type="text"
                              name="phoneNumber"
                              id="phoneNumber"
                              placeholder="Phone Number (optional)"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-12">
                          <div className="input-box">
                            <select
                              className="input-box-textarea"
                              required
                              name="relationship"
                              id="relationship"
                              value={relationship}
                              onChange={(e) => setRelationship(e.target.value)}>
                              <option value="">
                                Your Relationship to Outcess
                              </option>
                              {RELATIONSHIP_OPTIONS.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="input-box">
                            <select
                              className="input-box-textarea"
                              required
                              name="category"
                              id="category"
                              value={category}
                              onChange={(e) => setCategory(e.target.value)}>
                              <option value="">Nature of Grievance</option>
                              {CATEGORY_OPTIONS.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                      <div className="input-box">
                        <textarea
                          className="input-box-textarea"
                          placeholder="Please describe your grievance in detail..."
                          required
                          name="description"
                          id="description"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          rows={8}></textarea>
                      </div>
                      <div>
                        <button disabled={loading} type="submit">
                          {loading ? "Submitting..." : "Submit Grievance"}
                          <span className="flaticon-next"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GrievanceForm;
